import React, { useContext, useRef } from 'react';
import Title from '../resources/Title';
import { MainContext } from '../../context/MainContext'
import { UserContext } from '../../context/UserContext'
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import { DataGrid } from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import * as Constants from '../../components/api/constants'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useHistory } from 'react-router-dom';

function createData(id, email, firstName, lastName, client, verified, platform, login, resetPassword, verifyUser, deleteUser) {
  return { id, email, firstName, lastName, client, verified, platform, login, resetPassword, verifyUser, deleteUser };
}

let rows = [];
let permission = 0;

const cellRenderer = (params) => {
  return params.value;
};

export default function UsersList(props) {
  const { usersList, usersCount } = useContext(MainContext);
  const mainUserId = useContext(UserContext);

  const parent = props;
  const [open, setOpen] = React.useState(false);
  const [resetPasswordOpen, setResetPasswordOpen] = React.useState(false);
  const [email, setEmail] = React.useState(rows);
  const [userId, setUserId] = React.useState(0);
  const [page, setPage] = React.useState(0);
  const history = useHistory();
  const [sortModel, setSortModel] = React.useState([
    { field: "id", sort: "asc" }
  ])

  let columns = [
    { field: 'id', headerName: 'ID', minWidth: 60, disableColumnMenu: true },
    { field: 'email', headerName: 'Email', flex: 2, minWidth: 280, disableColumnMenu: true },
    { field: 'firstName', headerName: 'First Name', flex: 1, minWidth: 100, disableColumnMenu: true },
    { field: 'lastName', headerName: 'Last Name', flex: 1, minWidth: 100, disableColumnMenu: true },
    { field: 'client', headerName: 'Client', flex: 1, minWidth: 80, disableColumnMenu: true },
    { field: 'verified', headerName: 'Verified', flex: 1, minWidth: 100, disableColumnMenu: true },
    { field: 'platform', headerName: 'Platform', flex: 1, minWidth: 100, disableColumnMenu: true },
    { field: 'login', headerName: 'Login', flex: 1, minWidth: 100, renderCell: cellRenderer, sortable: false, disableColumnMenu: true },
    { field: 'resetPassword', headerName: 'Reset Password', flex: 1, minWidth: 100, renderCell: cellRenderer, sortable: false, disableColumnMenu: true },
    { field: 'verifyUser', headerName: 'Verify User', flex: 1, minWidth: 100, renderCell: cellRenderer, sortable: false, disableColumnMenu: true },
    { field: 'deleteUser', headerName: 'Delete User', flex: 1, minWidth: 100, renderCell: cellRenderer, sortable: false, disableColumnMenu: true },
  ];

  if (permission === 2) {
    columns = [
      { field: 'id', headerName: 'ID', minWidth: 60 },
      { field: 'email', headerName: 'Email', flex: 2, minWidth: 280 },
      { field: 'firstName', headerName: 'First Name', flex: 1, minWidth: 100 },
      { field: 'lastName', headerName: 'Last Name', flex: 1, minWidth: 100 },
      { field: 'login', headerName: 'Login', flex: 1, minWidth: 100, renderCell: cellRenderer },
    ];
  }

  rows = [];

  const tfName = useRef('');
  const tfSpa = useRef('');
  const tfEmail = useRef('');
  const tfSupportPin = useRef('');
  const tfUserId = useRef('');

  const [spinner, setSpinner] = React.useState(true);

  const [data, setData] = React.useState(rows);
  React.useEffect(() => {
    if (usersList === undefined) return;

    [...usersList].forEach(element => {
      rows.push(createData(element.id, element.email, element.firstName, element.lastName, element.client, element.verified ? "Yes" : "No",
        element.platform,
        element.hasSpa ? <Button variant="contained" type="submit" onClick={() => { handleLoginClickOpen(element.id, element.email) }}>Login</Button> :
          <Button variant="contained" color="success" type="submit" disabled>No Spa</Button>,
        <Button variant="contained" type="submit" onClick={() => { handleResetPasswordClickOpen(element.id, element.email) }}>Reset</Button>,
        element.verified ? <Button variant="contained" color="success" type="submit" disabled>Verify</Button> : <Button variant="contained" color="success" type="submit" onClick={() => { verifyUserAPI(element.id, element.email) }}>Verify</Button>,
        <Button variant="contained" color="error" type="submit" onClick={() => { handleDeleteClickOpen(element.id, element.email) }}>Delete</Button>))
    });

    setData(rows)
    setSpinner(false);
  }, [usersList])

  React.useEffect(() => {
    if (usersList !== undefined) {
      const s = sortModel?.[0] ?? { field: "id", sort: "asc" };
      parent.getUsersList(
        tfEmail.current.value,
        tfName.current.value,
        tfSpa.current.value,
        tfUserId.current.value,
        page,
        s.field,
        s.sort
      );
    }
  }, [page, sortModel]);

  const handleSearch = () => {
    setSpinner(true);
    parent.clearUsersList();
    parent.getUsersList(tfEmail.current.value, tfName.current.value, tfSpa.current.value, tfUserId.current.value, 0);
  };

  const onChangeHandler = (ev) => {
    if (tfEmail.current.value === '' &&
      tfName.current.value === '' && tfSpa.current.value === '' &&
      ev.key !== 'Enter') {
      setSpinner(true);
      parent.getUsersList(tfEmail.current.value, tfName.current.value, tfSpa.current.value, tfUserId.current.value, 0);
    }
  }

  const handleDeleteClickOpen = (id, email) => {
    setUserId(id)
    setEmail(email);
    setOpen(true);
  };

  const handleDeleteCloseDialog = () => {
    setOpen(false);
  }

  const handleDeleteClose = () => {
    setOpen(false);

    const requestOptions = {
      method: 'DELETE',
      credentials: "include"
    };

    const parameters = new URLSearchParams({
      id: userId,
      email: email,
    });

    fetch(Constants.baseURL + Constants.apiDeleteUser + '?' + parameters, requestOptions)
      .then(response => {
        if (!response.ok && response.status !== 404) {
          history.push('/');
        }

        if (response.ok) {
          parent.getUsersList();
          toast.success('User deleted successfully', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.error('Firmware upload failed. Please try again', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch(error => { console.log('request failed', error); });
  };

  // Reset password confirmation 
  const handleResetPasswordClickOpen = (id, email) => {
    setUserId(id)
    setEmail(email);
    setResetPasswordOpen(true);
  };

  const handleResetPasswordCloseDialog = () => {
    setResetPasswordOpen(false);
  }

  const handleResetPasswordClose = () => {
    setResetPasswordOpen(false);
    resetUserPasswordAPI(userId, email);
  };

  const [loginDialogOpen, setLoginDialogOpen] = React.useState(false);

  const handleLoginClickOpen = (id, email) => {
    setLoginDialogOpen(true);
    setUserId(id);
    setEmail(email);
  };

  const handleLoginClose = () => {
    setLoginDialogOpen(false);
  }

  const verifyUserAPI = (id, email) => {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ Id: id, Email: email }),
      credentials: "include"
    };

    fetch(Constants.baseURL + Constants.apiVerifyUser, requestOptions)
      .then((response) => {
        if (response.ok) {
          parent.getUsersList();
          toast.success('User verified successfully', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.error('Verification Failed. Please try again', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }).catch(error => { console.log('request failed', error); });
  }

  const resetUserPasswordAPI = (id, email) => {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ UserId: id, Email: email }),
      credentials: "include"
    };

    fetch(Constants.baseURL + Constants.apiResetUserPassword, requestOptions)
      .then((response) => {
        if (response.ok) {
          parent.getUsersList();
          toast.success('Reset Password Email Sent Successfully', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.error('Password Reset Failed. Please try again', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }).catch(error => { console.log('request failed', error); });
  }

  const handleLogin = () => {
    setLoginDialogOpen(false);

    const requestOptions = {
      method: 'GET',
      credentials: "include"
    };

    const parameters = new URLSearchParams({
      id: userId,
      pin: tfSupportPin.current.value,
      email: email
    });

    fetch(Constants.baseURL + Constants.apiPinLogin + '?' + parameters, requestOptions)
      .then(response => {
        if (response.ok) {
          mainUserId.setUserId(userId);
          setTimeout(function () {
            history.push('/Dashboard');
          }, 1000);
        } else {
          toast.error('Error logging in. Please try again', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch(error => { console.log('request failed', error); });
  };

  return (
    <React.Fragment>
      <ToastContainer />

      <Grid
        container
        spacing={1}
        alignItems="center"
        sx={{
          mb: 1,
          flexWrap: { xs: "wrap", sm: "nowrap" },
          justifyContent: { xs: "flex-start", sm: "flex-end" },
          "& .MuiGrid-item": { minWidth: 0, maxWidth: 250 },
        }}
      >
        {/* Title */}
        <Grid
          item
          xs={12}
          sm="auto"
          sx={{
            whiteSpace: "nowrap",
            mr: { xs: 0, sm: "auto" },
          }}
        >
          <Title>Users</Title>
        </Grid>

        <Grid item xs={12} sm>
          <TextField
            id="tfName"
            inputRef={tfName}
            label="Name"
            size="small"
            fullWidth
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            onChange={onChangeHandler}
          />
        </Grid>

        <Grid item xs={12} sm>
          <TextField
            id="tfSpa"
            inputRef={tfSpa}
            label="Spa"
            size="small"
            fullWidth
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            onChange={onChangeHandler}
          />
        </Grid>

        <Grid item xs={12} sm>
          <TextField
            id="tfEmail"
            inputRef={tfEmail}
            label="Email"
            size="small"
            fullWidth
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            onChange={onChangeHandler}
          />
        </Grid>

        <Grid item xs={12} sm>
          <TextField
            id="tfUserId"
            inputRef={tfUserId}
            label="User ID"
            size="small"
            fullWidth
            inputProps={{ inputMode: "numeric" }}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            onChange={onChangeHandler}
          />
        </Grid>

        {/* Button */}
        <Grid item xs={12} sm="auto">
          <Button
            variant="contained"
            onClick={handleSearch}
            fullWidth
            sx={{
              height: 40,
              whiteSpace: "nowrap",
              minWidth: 120,
            }}
          >
            Search
          </Button>
        </Grid>
      </Grid>

      <div style={{ height: 641, width: "100%", paddingTop: "10px" }}>
        <DataGrid
          sx={{
            "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
              outline: "none !important",
            },
            "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within": {
              outline: "none !important",
            },
          }}
          sortingOrder={["asc", "desc"]}
          rows={data}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[5]}
          checkboxSelection={false}
          isRowSelectable={false}
          disableSelectionOnClick
          loading={spinner}
          rowCount={usersCount}
          paginationMode="server"
          page={page}
          onPageChange={(newPage) => setPage(newPage)}
          sortingMode="server"
          sortModel={sortModel}
          onSortModelChange={(model) => {
            const next = model.length ? model : [{ field: "id", sort: "asc" }];
            setSortModel(next);
            setPage(0);
          }}
        />

        <Dialog
          open={open}
          keepMounted
          onClose={handleDeleteCloseDialog}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>{"Delete User"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Are you sure you want to delete this user: {email}?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteCloseDialog}>No</Button>
            <Button onClick={handleDeleteClose}>Yes</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={resetPasswordOpen}
          keepMounted
          onClose={handleResetPasswordCloseDialog}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>{"Reset User Password"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Are you sure you want to reset the password for user: {email}?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleResetPasswordCloseDialog}>No</Button>
            <Button onClick={handleResetPasswordClose}>Yes</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={loginDialogOpen} onClose={handleLoginClose}>
          <DialogTitle>Login</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please enter the user's support PIN to login
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              inputRef={tfSupportPin}
              label="Support PIN"
              fullWidth
              variant="standard"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleLoginClose}>Cancel</Button>
            <Button onClick={handleLogin}>Login</Button>
          </DialogActions>
        </Dialog>
      </div>
    </React.Fragment>
  );
}